import { StandardEvents } from '@shopify/events';

const data = document.getElementById('hoodie-gallery-sync-data');
if (data) {
  const { variants, mapUrl } = JSON.parse(data.textContent);
  const response = await fetch(mapUrl);
  if (!response.ok) throw Error('Hoodie media mapping unavailable');
  const mediaColors = await response.json();
  const section = document.querySelector('main media-gallery')?.closest('.shopify-section');
  let requestedMedia = null;
  let galleryChange = false;
  let galleryGesture = false;
  let selectionRevision = 0;
  // Native gallery morphs can emit scroll events without customer interaction.
  for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown']) {
    section?.addEventListener(type, event => {
      if (event.isTrusted && event.target.closest('media-gallery')) galleryGesture = true;
    }, { capture: true, passive: true });
  }
  const colorInput = () => section?.querySelector('variant-picker input[data-option-name="Color"]:checked');
  const gallery = () => section?.querySelector('media-gallery');
  function showSelection() {
    const color = colorInput()?.value;
    const native = variants.find(v => v.options.includes(color) && v.featured_media);
    const mediaId = requestedMedia && mediaColors[requestedMedia] === color
      ? requestedMedia : native?.featured_media?.id;
    if (mediaId) gallery()?.slideshow?.select({ id: String(mediaId) }, undefined, { animate: false });
  }
  section?.addEventListener('slideshow:select', event => {
    if (!event.detail.userInitiated || !event.target.closest('media-gallery')) return;
    if (event.detail.trigger === 'scroll' && !galleryGesture) return;
    const mediaId = String(event.detail.id);
    const color = mediaColors[mediaId];
    // Charts and media without an explicit reviewed mapping never select a variant.
    if (!color || colorInput()?.value === color) return;
    const input = [...section.querySelectorAll('variant-picker input[data-option-name="Color"]')]
      .find(input => input.value === color);
    if (!input) return;
    requestedMedia = mediaId;
    galleryChange = true;
    // Native picker resolves the same selected size, availability, ID, price and URL.
    // No replacement with a different color or size is performed here.
    input.click();
    galleryChange = false;
  });
  section?.addEventListener('change', event => {
    if (event.target.closest('variant-picker') && !galleryChange) requestedMedia = null;
  }, true);
  section?.addEventListener(StandardEvents.productSelect, event => {
    if (!event.target.closest('variant-picker')) return;
    galleryGesture = false;
    const revision = ++selectionRevision;
    section.dataset.hoodieSyncPending = 'true';
    event.promise.then(() => requestAnimationFrame(() => {
      if (revision === selectionRevision) {
        showSelection();
        section.dataset.hoodieSyncPending = 'false';
      }
    })).catch(error => {
      if (error?.name !== 'AbortError') console.warn('Hoodie gallery sync:', error);
    });
  });
  showSelection();
}
